import './footer.less';
import {eventsSender} from 'globalState/global-state.js';

$('.footer-problem').on('click', function() {
    eventsSender('problem', 'clickFooterButton', {
        isAuth: !window.config.user.isGuest
    });
});